const routes = [
    {
        path: "/course/topics",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "coursetopic_index"
        }
    }
]

export default routes;
